var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "imgBottom" },
    [
      _vm.datas.mode === 1
        ? _c("div", { staticClass: "img-container-stack" }, [
            _vm.datas.images && _vm.datas.images.length > 0
              ? _c(
                  "div",
                  { staticClass: "stack-wrapper" },
                  _vm._l(_vm.datas.images, function (img, index) {
                    return img.imgSrc
                      ? _c("img", {
                          key: index,
                          staticClass: "stack-img",
                          style: _vm.imgSizeStyle,
                          attrs: {
                            src: _vm.reqPath + img.imgSrc,
                            alt: img.title || "堆叠图片",
                          },
                        })
                      : _vm._e()
                  }),
                  0
                )
              : _c("div", { staticClass: "stack-placeholder" }, [
                  _c("i", {
                    staticClass: "el-icon-picture-outline default-icon",
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("暂无堆叠图片")]),
                ]),
          ])
        : _vm.datas.mode === 2
        ? _c("div", { staticClass: "img-container-carousel" }, [
            _vm.datas.images && _vm.datas.images.length > 0
              ? _c(
                  "div",
                  { staticClass: "carousel-wrapper" },
                  [
                    _c(
                      "el-carousel",
                      {
                        attrs: {
                          height: "150px",
                          trigger: "hover",
                          interval: _vm.carouselInterval,
                        },
                      },
                      _vm._l(_vm.datas.images, function (img, index) {
                        return _c("el-carousel-item", { key: index }, [
                          img.imgSrc
                            ? _c("img", {
                                staticClass: "carousel-img",
                                style: _vm.imgSizeStyle,
                                attrs: {
                                  src: _vm.reqPath + img.imgSrc,
                                  alt: img.title || "轮播图片",
                                },
                              })
                            : _vm._e(),
                        ])
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _c("div", { staticClass: "carousel-placeholder" }, [
                  _c("i", {
                    staticClass: "el-icon-picture-outline default-icon",
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("暂无轮播图片")]),
                ]),
          ])
        : _c("div", { staticClass: "img-container" }, [
            _vm.datas.imgSrc
              ? _c("img", {
                  staticClass: "img-content",
                  style: _vm.imgSizeStyle,
                  attrs: { src: _vm.reqPath + _vm.datas.imgSrc, alt: "" },
                })
              : _c("i", {
                  staticClass: "el-icon-picture-outline default-icon",
                }),
          ]),
      _vm._v(" "),
      _vm._t("deles"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }